import React from 'react';
import { InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const SemiCoveredSurface = ({ errors, touched }) => (
  <div>
    <label>Superficie semicubierta</label>
    <InputGroup size="sm" className="formWidths" style={{ maxWidth: '150px' }}>
      <InputGroup.Text id="basic-addon1">m2</InputGroup.Text>
      <Field className="form-control" name="surface.semiCoveredSurface" />
    </InputGroup>
    {errors.surface?.semiCoveredSurface &&
      touched.surface?.semiCoveredSurface && (
        <label className="w-100 text-danger mt-1">
          {errors.surface.semiCoveredSurface}
        </label>
      )}
  </div>
);

SemiCoveredSurface.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object
};
